import AdminLayout from '../Componets/AdminLayout';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';

export default function AdminHome() {
  const navigate = useNavigate();
  const [subjectCount, setSubjectCount] = useState(0);
  const [facultyCount, setFacultyCount] = useState(0);
  const [rejectanswersheetCount, setRejectanswersheetCount] = useState(0);
  const [studentCount, setStudentCount] = useState(0);
  const [examwCount, setExamwCount] = useState(0);
  const [lockExam, setLockExam] = useState(0);
  const [result, setResult] = useState(0);
  const [reassessment, setReassessment] = useState(0);
  const [totalStorageSizeMB, setTotalStorageSizeMB] = useState(0);
  const [Report, setReport] = useState(0);
  const apiUrl = process.env.REACT_APP_API_URL;
  const [dashboardCount, setDashboardCount] = useState(null);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    if (!localStorage.getItem('alertShown')) {
      notify();
      localStorage.setItem('alertShown', 'true');
    }
  }, []);

  const notify = () => toast.success('Login successfully');

  const animateCounter = (target, setCount) => {
    let start = 0;
    const duration = 600; // Duration for the animation
    const startTime = performance.now();

    const step = (timestamp) => {
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = Number.isInteger(target)
        ? Math.ceil(progress * target)
        : parseFloat((progress * target).toFixed(2));
      setCount(currentValue);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
      devtool: false,
    });
    AOS.refresh();
  }, []);

  useEffect(() => {
    const fetchRecords = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.get(`${apiUrl}/api/dashboard/admin`, {
          headers: {
            Authorization: token,
          },
        });
        const data = response.data;
        localStorage.setItem('ClientName', data.clintName);

        setDashboardCount(data);
      } catch (error) {
        console.error(
          error.response ? error.response.data.message : error.message
        );
        error.response?.status === 401 && navigate('/');
      }
    };

    fetchRecords();
  }, [apiUrl]);

  useEffect(() => {
    if (dashboardCount) {
      animateCounter(dashboardCount.subjectCount, setSubjectCount);
      animateCounter(dashboardCount.facultyCount, setFacultyCount);
      animateCounter(
        dashboardCount.rejectanswersheetCount,
        setRejectanswersheetCount
      );
      animateCounter(dashboardCount.StudentCount, setStudentCount);
      animateCounter(dashboardCount.workingExamCount, setExamwCount);
      animateCounter(dashboardCount.lockedExamCount, setLockExam);
      animateCounter(dashboardCount.resultCount, setResult);
      animateCounter(dashboardCount.reAssessment, setReassessment);
      animateCounter(dashboardCount.totalStorageSizeMB, setTotalStorageSizeMB);
      animateCounter(dashboardCount.examCount, setReport);
    }
  }, [dashboardCount]);

  return (
    <AdminLayout ac1="active">
      <main id="main" className="main">
        <div className="pagetitle mb-4">
          <h1>Dashboard</h1>
        </div>
        {/* ------------------------------------------  Page Title ---------------------------- */}
        <section id="stats" className="stats section">
          <div className="container" data-aos="fade-up" data-aos-delay="100">
            <div className="row gy-4">
              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/ListSubject')}
                key="subject"
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i className="bi bi-journal-bookmark-fill text-primary flex-shrink-0"></i>
                  <div>
                    <span>{subjectCount}</span>
                    <p>Subjects</p>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/ListFaculty')}
                key="faculty"
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-person-fill-gear flex-shrink-0"
                    style={{ color: '#ee6c20' }}
                  ></i>
                  <div>
                    <span>{facultyCount}</span>
                    <p>Faculties</p>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/StudentDasboard')}
                key="student"
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-mortarboard-fill flex-shrink-0"
                    style={{ color: '#bb0852' }}
                  ></i>
                  <div>
                    <span>{studentCount}</span>
                    <p>Total Student</p>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/ListExam')}
                key="working-exam"
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-clipboard2-data flex-shrink-0"
                    style={{ color: '#bb0852' }}
                  ></i>
                  <div>
                    <span>{examwCount}</span>
                    <p>Working Exams</p>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/ListExam')}
                key="locked-exam"
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-lock-fill flex-shrink-0"
                    style={{ color: '#bb0852' }}
                  ></i>
                  <div>
                    <span>{lockExam}</span>
                    <p>Locked Exams</p>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/ResultDasboard')}
                key="result"
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-award text-success flex-shrink-0"
                    style={{ color: '#bb0852' }}
                  ></i>
                  <div>
                    <span>{result}</span>
                    <p>Manage Result</p>
                  </div>
                </div>
              </div>

              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/ReasseDasboard')}
                key="reassessment"
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-bootstrap-reboot text-danger flex-shrink-0"
                    style={{ color: '#bb0852' }}
                  ></i>
                  <div>
                    <span>{reassessment}</span>
                    <p>Reassessment</p>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/RejectedDasboard')}
                key="exam"
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i
                    className="bi bi-clipboard2-x flex-shrink-0"
                    style={{ color: '#d32222' }}
                  ></i>
                  <div>
                    <span>{rejectanswersheetCount}</span>
                    <p>Reject sheet</p>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/Chart')}
                key="exam"
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i className="bi bi-database text-info flex-shrink-0"></i>
                  <div>
                    <span>
                      {totalStorageSizeMB >= 1024
                        ? `${(totalStorageSizeMB / 1024).toFixed(2)} `
                        : `${totalStorageSizeMB.toFixed(2)} `}
                      <p className="display-contents">
                        {totalStorageSizeMB >= 1024 ? 'GB' : 'MB'}
                      </p>
                    </span>
                    <p>Storage </p>
                  </div>
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 cursor-pointer"
                onClick={() => navigate('/ReportDashbord')}
                key="exam"
              >
                <div className="stats-item d-flex align-items-center w-100 h-100">
                  <i className="bi bi-file-bar-graph text-warning flex-shrink-0"></i>
                  <div>
                    <span>{Report}</span>
                    <p>Report </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <ToastContainer />
    </AdminLayout>
  );
}
